// CompetitionContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { auth, getIdToken } from './Firebase'; // Zakładam, że getIdToken jest dostępny

export const CompetitionContext = createContext();

export function CompetitionProvider({ children }) {
  const [competitions, setCompetitions] = useState({});
  const [loading, setLoading] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (authLoading) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const token = await getIdToken(auth.currentUser); // Pobierz token JWT
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/competitions`, { headers });
        setCompetitions(response.data);
      } catch (error) {
        console.error('Error fetching competitions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading]);

  const updateCompetition = (competitionId, newSimulationId) => {
    setCompetitions(prev => {
      const updatedCompetitions = { ...prev };
      const comps = Object.values(updatedCompetitions).flat();
      const compIndex = comps.findIndex(comp => comp.competition_id === competitionId);
      if (compIndex !== -1) {
        const comp = { ...comps[compIndex] };
        comp.simulation_ids = [...(comp.simulation_ids || []), { simulation_id: newSimulationId, created_at: new Date().toISOString(), conditions: "" }];
        comp.latest_simulation_id = newSimulationId;
        comps[compIndex] = comp;
        return { ...updatedCompetitions, [competitionId]: comps };
      }
      return prev;
    });
  };

  const refreshCompetitions = async () => {
    setLoading(true);
    try {
      const token = await getIdToken(auth.currentUser);
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/competitions`, { headers });
      setCompetitions(response.data);
    } catch (error) {
      console.error('Error refreshing competitions:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CompetitionContext.Provider value={{ competitions, loading, updateCompetition, refreshCompetitions }}>
      {children}
    </CompetitionContext.Provider>
  );
}

export const useCompetitions = () => useContext(CompetitionContext);